import Cube from './Cube';
import type { ModuleId, CubeType } from '../types';

interface Props {
  onSelect: (id: ModuleId) => void;
  mode: 'standby' | 'active';
  cubeType: CubeType;
}

export default function CubeScene({ onSelect, mode, cubeType }: Props) {
  return (
    <Cube 
      onSelect={onSelect} 
      mode={mode}
      cubeType={cubeType}
    />
  );
}
